import { createSelector } from 'reselect'
import getSearchRouterSelect from 'modules/router/selectors/get-search'
import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'

const getUrlQuerySearchSelect = createSelector(
  getSearchRouterSelect,
  search => {
    const queryParams = getQueryParamsFromStringObjectUtil(search)
    return queryParams?.q || ''
  }
)

export default getUrlQuerySearchSelect
